import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import { aiPetitionRecommendations } from 'src/app/pages/startAPetitionV2/shared/api';
import { generateRecommendedPetitionAnglesJob } from 'src/app/shared/api/recommendedPetitionAngles';
import { useAsyncJob } from 'src/app/shared/hooks/asyncJob';

type MutationFnInput = { mainPrompt: string; personalStory?: string };
type QueryFnReturn = Awaited<ReturnType<typeof aiPetitionRecommendations>>;

type AsyncJobParams = Parameters<typeof useAsyncJob<QueryFnReturn, MutationFnInput>>[0];
type UseRecommendationsJobOptions = Pick<AsyncJobParams, 'jobId' | 'onSuccess' | 'onError'>;

export function useRecommendationsJob(options: UseRecommendationsJobOptions = {}) {
	const utilityContext = useUtilityContext();

	return useAsyncJob({
		timeout: 30_000, // 30 seconds
		mutationFn: async (input: MutationFnInput) => {
			const jobResponse = await generateRecommendedPetitionAnglesJob(
				{
					mainPrompt: input.mainPrompt,
					personalStory: input.personalStory,
				},
				utilityContext,
			);

			return {
				jobId: jobResponse.responseId,
			};
		},

		queryFn: async (jobId) => aiPetitionRecommendations(jobId, utilityContext),
		...options,
	});
}
